import { render, staticRenderFns } from "./BecasObtenidas.vue?vue&type=template&id=6a7c4513&"
import script from "./BecasObtenidas.vue?vue&type=script&lang=js&"
export * from "./BecasObtenidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports